import { axios } from "../../helpers/axios";
import {
    LOGIN_URL,
} from "./authConstants";

// Move to users store

export const api_login_url = async (data) => {
    return axios.post(LOGIN_URL, data);
};